export const dhbs = [
  { label: 'Auckland', value: 'Auckland' },
  { label: 'Bay of Plenty', value: 'Bay of Plenty' },
  { label: 'Canterbury', value: 'Canterbury' },
  { label: 'Capital and Coast', value: 'Capital and Coast' },
  { label: 'Counties Manukau', value: 'Counties Manukau' },
  { label: "Hawke's Bay", value: "Hawke's Bay" },
  { label: 'Hutt Valley', value: 'Hutt Valley' },
  { label: 'Midcentral', value: 'Midcentral' },
  { label: 'Nelson Marlborough', value: 'Nelson Marlborough' },
  { label: 'Northland', value: 'Northland' },
  { label: 'Lakes', value: 'Lakes' },
  { label: 'South Canterbury', value: 'South Canterbury' },
  { label: 'Southern', value: 'Southern' },
  { label: 'Tairawhiti', value: 'Tairawhiti' },
  { label: 'Taranaki', value: 'Taranaki' },
  { label: 'Waikato', value: 'Waikato' },
  { label: 'Wairarapa', value: 'Wairarapa' },
  { label: 'Waitemata', value: 'Waitemata' },
  { label: 'Whanganui', value: 'Whanganui' },
  { label: 'West Coast', value: 'West Coast' },
];

export const tas = [
  { label: 'Ashburton District', value: 'Ashburton District' },
  { label: 'Auckland', value: 'Auckland' },
  { label: 'Buller District', value: 'Buller District' },
  { label: 'Carterton District', value: 'Carterton District' },
  { label: "Central Hawke's Bay District", value: "Central Hawke's Bay District" },
  { label: 'Central Otago District', value: 'Central Otago District' },
  { label: 'Chatham Islands Territory', value: 'Chatham Islands Territory' },
  { label: 'Christchurch City', value: 'Christchurch City' },
  { label: 'Clutha District', value: 'Clutha District' },
  { label: 'Dunedin City', value: 'Dunedin City' },
  { label: 'Far North District', value: 'Far North District' },
  { label: 'Gisborne District', value: 'Gisborne District' },
  { label: 'Gore District', value: 'Gore District' },
  { label: 'Grey District', value: 'Grey District' },
  { label: 'Hamilton City', value: 'Hamilton City' },
  { label: 'Hastings District', value: 'Hastings District' },
  { label: 'Hauraki District', value: 'Hauraki District' },
  { label: 'Horowhenua District', value: 'Horowhenua District' },
  { label: 'Hurunui District', value: 'Hurunui District' },
  { label: 'Invercargill City', value: 'Invercargill City' },
  { label: 'Kaikoura District', value: 'Kaikoura District' },
  { label: 'Kaipara District', value: 'Kaipara District' },
  { label: 'Kapiti Coast District', value: 'Kapiti Coast District' },
  { label: 'Kawerau District', value: 'Kawerau District' },
  { label: 'Lower Hutt City', value: 'Lower Hutt City' },
  { label: 'Mackenzie District', value: 'Mackenzie District' },
  { label: 'Manawatu District', value: 'Manawatu District' },
  { label: 'Marlborough District', value: 'Marlborough District' },
  { label: 'Masterton District', value: 'Masterton District' },
  { label: 'Matamata-Piako District', value: 'Matamata-Piako District' },
  { label: 'Napier City', value: 'Napier City' },
  { label: 'Nelson City', value: 'Nelson City' },
  { label: 'New Plymouth District', value: 'New Plymouth District' },
  { label: 'Opotiki District', value: 'Opotiki District' },
  { label: 'Otorohanga District', value: 'Otorohanga District' },
  { label: 'Palmerston North City', value: 'Palmerston North City' },
  { label: 'Porirua City', value: 'Porirua City' },
  { label: 'Queenstown-Lakes District', value: 'Queenstown-Lakes District' },
  { label: 'Rangitikei District', value: 'Rangitikei District' },
  { label: 'Rotorua District', value: 'Rotorua District' },
  { label: 'Ruapehu District', value: 'Ruapehu District' },
  { label: 'Selwyn District', value: 'Selwyn District' },
  { label: 'South Taranaki District', value: 'South Taranaki District' },
  { label: 'South Waikato District', value: 'South Waikato District' },
  { label: 'South Wairarapa District', value: 'South Wairarapa District' },
  { label: 'Southland District', value: 'Southland District' },
  { label: 'Stratford District', value: 'Stratford District' },
  { label: 'Tararua District', value: 'Tararua District' },
  { label: 'Tasman District', value: 'Tasman District' },
  { label: 'Taupo District', value: 'Taupo District' },
  { label: 'Tauranga City', value: 'Tauranga City' },
  { label: 'Thames-Coromandel District', value: 'Thames-Coromandel District' },
  { label: 'Timaru District', value: 'Timaru District' },
  { label: 'Upper Hutt City', value: 'Upper Hutt City' },
  { label: 'Waikato District', value: 'Waikato District' },
  { label: 'Waimakariri District', value: 'Waimakariri District' },
  { label: 'Waimate District', value: 'Waimate District' },
  { label: 'Waipa District', value: 'Waipa District' },
  { label: 'Wairoa District', value: 'Wairoa District' },
  { label: 'Waitaki District', value: 'Waitaki District' },
  { label: 'Waitomo District', value: 'Waitomo District' },
  { label: 'Wellington City', value: 'Wellington City' },
  { label: 'Western Bay of Plenty District', value: 'Western Bay of Plenty District' },
  { label: 'Westland District', value: 'Westland District' },
  { label: 'Whakatane District', value: 'Whakatane District' },
  { label: 'Whanganui District', value: 'Whanganui District' },
  { label: 'Whangarei District', value: 'Whangarei District' },
  { label: 'Area Outside Territorial Authority', value: 'Area Outside Territorial Authority' },
];

export const types = [
  { label: 'All Oral Health Practitioners', value: '' },
  { label: 'Adult care in dental therapy practice', value: 'Adult care in dental therapy practice' },
  { label: 'Clinical dental technology practice', value: 'Clinical dental technology practice' },
  { label: 'Dental hygiene practice', value: 'Dental hygiene practice' },
  { label: 'Dental technology practice', value: 'Dental technology practice' },
  { label: 'Dental therapy practice', value: 'Dental therapy practice' },
  { label: 'Endodontic specialist', value: 'Endodontic specialist' },
  { label: 'General dental practice', value: 'General dental practice' },
  {
    label: 'Implant overdentures in clinical dental technology practice',
    value: 'Implant overdentures in clinical dental technology practice',
  },
  { label: 'Oral and maxillofacial surgery specialist', value: 'Oral and maxillofacial surgery specialist' },
  { label: 'Oral health therapy practice', value: 'Oral health therapy practice' },
  { label: 'Oral medicine specialist', value: 'Oral medicine specialist' },
  { label: 'Oral pathology specialist', value: 'Oral pathology specialist' },
  { label: 'Oral surgery specialist', value: 'Oral surgery specialist' },
  { label: 'Orthodontic auxiliary practice', value: 'Orthodontic auxiliary practice' },
  { label: 'Orthodontic specialist', value: 'Orthodontic specialist' },
  { label: 'Paediatric dentistry specialist', value: 'Paediatric dentistry specialist' },
  { label: 'Periodontic specialist', value: 'Periodontic specialist' },
  { label: 'Prosthodontic specialist', value: 'Prosthodontic specialist' },
  { label: 'Public health dentistry specialist', value: 'Public health dentistry specialist' },
  { label: 'Restorative dentistry specialist', value: 'Restorative dentistry specialist' },
  { label: 'Special needs dentistry specialist', value: 'Special needs dentistry specialist' },
];
